import { render, staticRenderFns } from "./Tenders.vue?vue&type=template&id=0ccc90e8&"
import script from "./Tenders.vue?vue&type=script&lang=js&"
export * from "./Tenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports